function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFC905",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.967 0l-9.916 29.967L8.833 0H0l14.419 40.52h8.703L37.627 0h-8.66zM42.966 0v40.52h8.14V0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M85.865 4.56c-1.56-2.04-3.464-3.344-5.802-3.951C78.547.174 75.343 0 70.363 0H57.288v40.52h8.14V25.233h5.327c3.68 0 6.495-.217 8.443-.564a12.045 12.045 0 0 0 4.243-1.955c1.386-.956 2.554-2.301 3.42-3.995.91-1.695 1.386-3.78 1.386-6.254 0-3.214-.822-5.864-2.38-7.905zm-6.971 11.162c-.606.912-1.472 1.563-2.555 1.998-1.082.434-3.204.608-6.451.608h-4.46V6.862h3.94c2.944 0 4.893.087 5.889.261 1.298.26 2.424.825 3.247 1.78.867.956 1.299 2.172 1.299 3.649 0 1.215-.303 2.258-.91 3.17z"
}));

function SvgVip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 41,
    viewBox: "0 0 89 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.884f88ab.svg";
export { ForwardRef as ReactComponent };